export default __webpack_public_path__ + "static/media/ExerciseBackgroundImage.e7dbcd31.png";